import React, { useState } from "react";
import { Table as AntdTable } from "antd";
import toast from "react-hot-toast";

import { IEmpresaProps, IFetchPropsEmpresas } from "../../types";
import { api } from "../../../../services/api";
import { getSubDomain } from "../../../../hooks/getSubDomain";
import { TableColumnController } from "./tableColumnController";
import { TableRowSelection } from "antd/lib/table/interface";

interface ITableComponentProps {
  dataFetch?: IFetchPropsEmpresas;
  isLoading: boolean;
  refetch: () => void;
  currentPage: number;
  itensPerPage: number;
  setCurrentPage: (event: number) => void;
  setColumnOrdenation: (event: string) => void;
  setItensPerPage: (event: number) => void;
  totalItens: number;
}

export function TableComponent({ 
  refetch, 
  dataFetch, 
  totalItens,
  isLoading, 
  itensPerPage, 
  currentPage,
  setCurrentPage,
  setColumnOrdenation,
  setItensPerPage
}: ITableComponentProps) {
  const pageSizeOptions = ["10", "20", "30"]

  const [selectDataKeys, setSelectDataKeys] = useState<any>({ keys: [], data: []})

  const rowSelection: TableRowSelection<IEmpresaProps> = {
    selectedRowKeys: selectDataKeys.keys,
    onChange: (keys, data) => {
      setSelectDataKeys({ keys: keys as string[], data })
    },
    selections: [
      {
        key: 'odd',
        text: 'Apagar Selecionados',
        onSelect: () => {
          console.log(selectDataKeys)
        },
      },
    ]
  };

  function onChange(pagination: any, filters: any, sorter: any) {
    setCurrentPage(pagination.current);
    setItensPerPage(pagination.pageSize);

    if (sorter.order === "descend") {
      setColumnOrdenation(`${sorter.field}:DESC`)
    } else if (sorter.order === "ascend") {
      setColumnOrdenation(`${sorter.field}:ASC`)
    } else {
      setColumnOrdenation(``)
    }
  }

  async function handleDeleteFunction(empresaId: string) {
    try {
      await api.delete(getSubDomain() + `empresas/${empresaId}`);
      toast.success("Desativado com sucesso");
    } catch(err) {
      toast.error("Não foi possivel Desativar");
      console.log(err)
    }
    refetch();
  }

  async function handleRestoreFunction(empresaId: string) {
    try {
      await api.put(getSubDomain() + `empresas/restore/${empresaId}`);
      toast.success("Ativado com sucesso");
    } catch(err) {
      toast.error("Não foi possivel Ativar");
      console.log(err)
    }
    refetch();
  }

  const { columns, data } = TableColumnController({ 
    handleDeleteFunction,
    handleRestoreFunction,  
    refetch, 
    dataList: dataFetch 
  });

  return (
    <AntdTable
      loading={isLoading}
      showSorterTooltip={false}
      rowSelection={rowSelection}
      onChange={onChange}
      dataSource={data}
      columns={columns}
      pagination={{ 
        current: currentPage, 
        pageSize: itensPerPage, 
        pageSizeOptions,
        total: totalItens,
        showSizeChanger: true
      }}
    />
  );
}
